import React from 'react';
import proptypes from 'prop-types';
const { func, arrayOf, shape, string, bool } = proptypes;
import { TemplateImage } from '../TemplateImage/TemplateImage';
import './four-appliance-template.scss';

export const FourApplianceTemplate = ({ images, handlePlaceholderClick, customStyles, filterResponse }) => {

  if (!images.length) {
    return null;
  }

  return (
    <div
      data-testid="four-appliance-template"
      className={`package-image-grid-container ${customStyles}`}
      data-component="FourApplianceTemplate"
    >
      {
        images.slice(0, 4).map((product) => {
          return (
            <div key={product.itemId} className={product.active && 'package-image-grid-container__product-img'}>
              <TemplateImage
                product={product}
                handlePlaceholderClick={handlePlaceholderClick}
                filterResponse={filterResponse}
              />
            </div>
          );
        })
      }
    </div>
  );
};

FourApplianceTemplate.propTypes = {
  images: arrayOf(shape({
    url: string.isRequired,
    itemId: string.isRequired,
    active: bool.isRequired
  })).isRequired,
  handlePlaceholderClick: func.isRequired,
  customStyles: string,
  filterResponse: bool
};

FourApplianceTemplate.defaultProps = {
  customStyles: null,
  filterResponse: true
};